import React, { useEffect, useState } from "react";
import { parseEmailHtml } from "../../utils/parse/parse";

const Dummy = {
  customer: {
    firstName: "John",
    lastName: "Doe",
    fullName: "John Doe",
    accountNumber: "12345",
  },
  user: { firstName: "Support", lastName: "Team" },
  company: { name: "Gibit" },
};

const TemplatePreview = ({ html, isSms }) => {
  const [parsed, setParsed] = useState(
    parseEmailHtml(Dummy.customer, Dummy.user, Dummy.company, html),
  );

  useEffect(() => {
    setParsed(parseEmailHtml(Dummy.customer, Dummy.user, Dummy.company, html));
  }, [html]);

  return (
    <div
      className="mt-3 p-4 border rounded-lg bg-white dark:bg-gray-900"
      dangerouslySetInnerHTML={!isSms ? { __html: parsed } : undefined}
    >
      {isSms ? parsed : null}
    </div>
  );
};

export default TemplatePreview;
